import { render } from "./WebPlacebet.vue?vue&type=template&id=c1e8895c&scoped=true"
import script from "./WebPlacebet.vue?vue&type=script&lang=js"
export * from "./WebPlacebet.vue?vue&type=script&lang=js"

import "./WebPlacebet.vue?vue&type=style&index=0&id=c1e8895c&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e8895c"]])

export default __exports__